import { Ng2StateDeclaration } from "@uirouter/angular";
import { StateParams } from "@uirouter/core";
import { IMenu } from "app/types/menu";
import { ErrorPageComponent } from "./error.component";
import { OpPrimarySidebarService } from "app/components/opPrimarySidebar/opPrimarySidebar.service";

export const errorStateDeclaration: Ng2StateDeclaration = {
  name: 'error',
  url: '/error',
  redirectTo: 'error.404',
  component: ErrorPageComponent,
  params: {
    error: {
      dynamic: true,
      type: 'any',
      value: null
    },
    menuOptions: {
      dynamic: true,
      value: {
        sections: []
      }
    }
  },
  resolve: {
    error: ['$stateParams', (params: StateParams) => params.error],
    home: [
      '$stateParams',
      OpPrimarySidebarService,
      (params: StateParams, sidebar: OpPrimarySidebarService) => {
        const current = sidebar.current;
        const sections = current.sections?.length > 0 ? current.sections : params.menuOptions?.sections;
        return _find(sections);
      }
    ],
    sections: [
      '$stateParams',
      OpPrimarySidebarService,
      (params: StateParams, sidebar: OpPrimarySidebarService) => {
        const current = sidebar.current;
        const sections = current.sections?.length > 0 ? current.sections : params.menuOptions?.sections;
        return _reduce([], sections);
      }
    ]
  }
}

function _reduce(acc: IMenu[], sections: IMenu[]) {
  sections.forEach(item => {
    if (item.favorite && !item.home && (item.stateName || item.link)) acc.push(item);
    if (item.submenu) acc = _reduce(acc, item.submenu);
  });
  return acc;
}

function _find(sections: IMenu[]) {
  for (let item of sections) {
    if (item.home) return item;
    else if (item.submenu) {
      const result = _find(item.submenu);
      if (result) return result;
    }
  }
}
